import { PodError, PodSearchResult } from "../../../api/pods.types";
import { MarketGroupOption, ProviderOption } from "./reducer";

export const SET_READY = 'SET_READY';
export const SET_LOAD_ERROR = 'SET_LOAD_ERROR';
export const SET_IS_SEARCHING = 'SET_IS_SEARCHING';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const SET_SEARCH_ERROR = 'SET_SEARCH_ERROR';
export const SET_USER_IS_MANAGER = 'SET_USER_IS_MANAGER';
export const SET_MARKETREGIONS = 'SET_MARKETREGIONS';
export const SET_PROVIDERLIST = 'SET_PROVIDERLIST';

export const setReady = (ready: boolean) => ({
  type: SET_READY,
  data: ready,
});

export const setLoadError = (error?: string) => ({
  type: SET_LOAD_ERROR,
  data: error,
});

export const setIsSearching = (query: string) => ({
  type: SET_IS_SEARCHING,
  data: query,
});

export const setSearchResults = (results: PodSearchResult[]) => ({
  type: SET_SEARCH_RESULTS,
  data: results,
});

export const setSearchError = (error: PodError) => ({
  type: SET_SEARCH_ERROR,
  data: error,
});

export const setUserIsManager = (isManager: boolean) => ({
  type: SET_USER_IS_MANAGER,
  data: isManager,
});

export const setMarketRegions = (marketGroups: MarketGroupOption[], regions: string[]) => ({
  type: SET_MARKETREGIONS,
  data: {
    marketGroups,
    regions
  },
});

export const setProviderList = (physicians: ProviderOption[], others: ProviderOption[]) => ({
  type: SET_PROVIDERLIST,
  data: {
    physicians,
    others
  },
});